import React, { Component } from 'react'

export default WrappedComponent =>
  class FavouritesWrapper extends Component {
    constructor(props) {
      super(props)
      const favourites = this.getFavourites()
      this.state = {
        favourites
      }
    }
    getFavourites = () => {
      return JSON.parse(window.localStorage.getItem('favourites')) || []
    }
    toggleFavourite = (e, id) => {
      e.preventDefault()
      const favourites = this.getFavourites()
      const updatedFavourites = favourites.includes(id)
        ? favourites.filter(_value => _value !== id)
        : [...favourites, id]
      this.setState({ favourites: updatedFavourites })
      window.localStorage.setItem(
        'favourites',
        JSON.stringify(updatedFavourites)
      )
      console.log(updatedFavourites)
    }
    render() {
      return (
        <WrappedComponent
          {...this.props}
          favourites={this.state.favourites}
          toggleFavourite={this.toggleFavourite}
        />
      )
    }
  }
